import React, { useEffect } from 'react';
import { array, func } from 'prop-types';
import Interaction from '../../components/Interaction/Interaction';

/**
 * Interactions List.
 * @returns {React.component} A list of interactions to render.
 */
const InteractionList = (props) => {

  // Fetch and set user interactions only when component is rendered.
  useEffect(() => {
    props.fetchAndSetInteractions();
  }, []);

  const interactionNodes = props.interactions.map((interaction, index) => {
    return (
      <Interaction
        key={interaction.id}
        interaction={interaction}
      />
    );
  });

  return (
    <ul className="interaction-list">
      {interactionNodes}
    </ul>
  );
};

/**
 * Validation on passed-in props.
 * @type {Object}
 */
InteractionList.propTypes = {
  interactions: array.isRequired,
  setProfileUserInteractions: func,
};

export default InteractionList;



// WEBPACK FOOTER //
// ./src/components/InteractionList/InteractionList.js